import Image from 'next/image';

import styles from './Close.module.scss';

const Close = ({close=null, size="md"}) => {
    return ( 
        <div className={`${styles["cross"]} ${styles["cross-"+size]}`} onClick={close}>
            <Image src="/cross.svg" alt="close" priority={true} height="100%" width="100%" />
        </div>
     );
}
 
export default Close;